import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Constant } from '../../../environments/constants';
import { Utils } from '../../../utils/utils';
import { Subscription } from 'rxjs';
import { ContextService } from '../../services/context/context.service';
import { DataService } from '../../services/context/data.service';
import { UIStateService } from '../../services/context/uistate.service';
import { AccountsService } from '../../services/accounts.service';
import { ExternalAccountService } from '../../services/external-account.service';
import { AppMonitoringService } from '../../services/util/app-monitoring.service';
import * as fromModel from '../../services/models';

import {MatTableDataSource} from '@angular/material/table';
import {SelectionModel} from '@angular/cdk/collections';

@Component({
  selector: 'gp-account-list',
  templateUrl: './account-list.component.html',
  styleUrls: ['./account-list.component.scss']
})
export class AccountListComponent implements OnInit, OnDestroy, OnChanges {

  protected _storeDataSubscription: Subscription;
  @Input('SaveId') saveId: string;
  @Input('ListType') listType: string = 'AST'; //LB or AST or blank
  //@Output() onSave: EventEmitter<any> = new EventEmitter();
  
  Accounts: any = [];
  SelectedAccounts: any = [];
  //displayedColumns: string[] = ['select', 'id', 'legalEnityName', 'taxstatus', 'modelName', 'AccountKPIs.AccountTotal'];
  displayedColumns: string[] = ['select', 'id', 'taxstatus', 'modelName', 'actions', 'AccountKPIs.AccountTotal'];
  dataSource = new MatTableDataSource<any>(this.Accounts);
  selection = new SelectionModel<any>(true, []);

  clientMenuItems = [];
  
  isDataChanged = false;
  constructor(private accountsService: AccountsService,
    private externalAccountService: ExternalAccountService,
    private contextService:ContextService,
    private dataService:DataService,
    private uiStateService: UIStateService,
    private appMonitoringService: AppMonitoringService) {      
    }

  ngOnInit(): void {
    if(this.contextService.context.Account && this.contextService.context.Account.length>0){
      this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWPROGRESSBAR, "AccountListComponent-ngOnInit", true);
        //this.dataService.getAccounts(this.contextService.context.Account);        
    }
    this._storeDataSubscription = this.dataService.subscribe((appData: fromModel.IAppData) => this.populateAppData(appData));   

    //let clients: fromModel.PlanClient[] = this.dataService.getPlanPrimarSecondaryOwners();
    let clients: fromModel.PlanClient[] = this.dataService.getPlanClients();
    if(clients && clients.length>0){
      clients.forEach(cl => {
        this.clientMenuItems.push({clientid: cl.clientid, displayClientname: `${cl.clientname}`});    
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    //this.save();    
  }

  private populateAppData(appData: fromModel.IAppData){
    if(appData && appData.action!==fromModel.DATA_ACTION.NONE){

      

      this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWPROGRESSBAR, "AccountListComponent-populateAppData", true);
      if(this.dataService.appData.Accounts 
          && this.dataService.appData.Accounts["value"] 
          && this.dataService.appData.Accounts["value"].length>0){    
            // const lbAccounts =  this.dataService.appData.Accounts["value"].filter(val=>val.registrationtype==='LB');       
            // const astAccounts =  this.dataService.appData.Accounts["value"].filter(val=>val.registrationtype!=='LB');
            this.Accounts = this.dataService.appData.Accounts["value"].filter(val=>val.registrationtype!=='LB');

            // this.Accounts = [];            
            // if(this.listType === "LB"){
            //   lbAccounts.forEach(acc => {
            //     this.Accounts.push(acc);
            //   });

            //   astAccounts.forEach(acc => {
            //     this.Accounts.push(acc);
            //   });             
            // } else {
            //   astAccounts.forEach(acc => {
            //     this.Accounts.push(acc);
            //   });
            //   lbAccounts.forEach(acc => {
            //     this.Accounts.push(acc);
            //   });
            // }            
            this.SelectedAccounts = [];
            this.Accounts.forEach(acc => {
              const selectedAccount = this.contextService.context.SelectedAccounts.find(actNo=>actNo === acc.id);
              //const selectedAccount = this.dataService.appData.Plan.planAccounts.find(plAcc=>plAcc.actNo === acc.id);
              if(selectedAccount){
                this.SelectedAccounts.push(acc);
              }
          });
          

          this.dataSource = new MatTableDataSource<any>(this.Accounts);
          this.selection = new SelectionModel<any>(true, this.SelectedAccounts);          
          this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWPROGRESSBAR, "AccountListComponent-populateAppData", false);

      } else if(this.dataService.appData.Accounts && this.dataService.appData.Accounts["Error"]) {  

        this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWERRORMSG, "AccountListComponent-populateAppData", {ShowMsg: true, MsgType: fromModel.MSGTYPE.ERROR, Msg: Constant.ErrorMsgs.systemErrorMsg});
        //this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWPROGRESSBAR, "CashFlowComponent-populateAppData", false);         

      }

     
      this.populateHypotheticalAccList();
      
     
    }
  }

  populateHypotheticalAccList(){

    let ExternalAccounts: any = [];
    let allAccounts: any = [];
       
    if(this.dataService.appData.ExternalAccounts 
      && this.dataService.appData.ExternalAccounts["accounts"] 
      && this.dataService.appData.ExternalAccounts["accounts"].length>0){  

        this.dataService.appData.ExternalAccounts["accounts"].forEach(acc => {
          const tempAcc = this.Accounts.find(_acc=>_acc.id === acc.id);
          if(tempAcc){
            const posTempAcc = this.Accounts.indexOf(tempAcc);
            this.Accounts.splice(posTempAcc,1);
            //do nothing - account is already there in the list
          } 

          let eaData = {
            custodianType: fromModel.CUSTODIANTYPE.HypoEA,  
            id: acc.id,
            accounttype: acc.actTypeDesc,
            LegalEntityName: this.dataService.getPlanClientByClientId(acc.clientid)?this.dataService.getPlanClientByClientId(acc.clientid).clientname:acc.clientname,
            legalEnityId: acc.clientid,
            //eaBase: acc.eaBase,
            AccountKPIs: {AccountTotal: acc.mktValue},
            mktValue: acc.mktValue,
            accountNickname: acc.name,
            shortName: acc.name,
            taxstatus: Utils.getTaxStatusDisplayName(acc.taxstatus),
            modelName:''
          };

          ExternalAccounts.push(eaData);
          const selectedExternalAccount = this.contextService.context.SelectedExternalAccounts.find(accID=>accID === acc.id);
          if(selectedExternalAccount && selectedExternalAccount.length>0){
            const _acc = this.SelectedAccounts.find(ac=>ac.id === eaData.id);
            if(_acc){ 
              const pos =  this.SelectedAccounts.indexOf(_acc);
              if(pos > -1){
                this.SelectedAccounts.splice(pos, 1);                        
              }
            }
            this.SelectedAccounts.push(eaData);
          }            
        });

        let sortBy = [
          {
            prop: 'custodianType',
            direction: 1,
            number: false
          },
          {
            prop: "mktValue",
            direction: -1,
            number: true
          }
        ];
        Utils.multiplesort(ExternalAccounts, sortBy);          


        this.Accounts.forEach(element => {
          allAccounts.push(element);
          
        });
        
        ExternalAccounts.forEach(element => {
          allAccounts.push(element);
          
        });
        this.dataSource = new MatTableDataSource<any>(allAccounts);
        this.selection = new SelectionModel<any>(true, this.SelectedAccounts);
      }      
  }

  masterToggle() {
    if(this.dataSource && this.dataSource.data && this.dataSource.data.length){
      this.isDataChanged = true;
      this.isAllSelected() ?
          this.selection.clear() :
          this.dataSource.data.forEach(row => this.selection.select(row));
    }
  }

  selectionToggle(row){
    this.isDataChanged = true;
    this.selection.toggle(row);    
  }

  isAllSelected() {
    if(this.dataSource && this.dataSource.data && this.dataSource.data.length){
      const numSelected = this.selection.selected.length;
      const numRows = this.dataSource.data.length;
      return numSelected === numRows;
    }
  }


  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;
  }

  changeAccountSelection(event, row){
    event? this.selection.toggle(row) : null;
    this.updateSelectedAccountInLocalcache();    
    // let selectedAccount = [];
    // this.selection.selected.forEach(s => selectedAccount.push(s.id));    
    // this.contextService.dispatchAction(fromModel.APP_ACTION.SELECTEDACCOUNTS, "AccountListComponent-changeAccountSelection", selectedAccount);
    // this.dataService.dispatchAction(fromModel.DATA_ACTION.SELECTEDPLANACCOUNTS, "AccountListComponent-changeAccountSelection", selectedAccount);
  } 

  changeAllAccountSelection(event){
    event ? this.masterToggle() : null;
    this.updateSelectedAccountInLocalcache();
    // let selectedAccount = [];
    // this.selection.selected.forEach(s => selectedAccount.push(s.id));
    // this.contextService.dispatchAction(fromModel.APP_ACTION.SELECTEDACCOUNTS, "AccountListComponent-changeAccountSelection", selectedAccount);
    // this.dataService.dispatchAction(fromModel.DATA_ACTION.SELECTEDPLANACCOUNTS, "AccountListComponent-changeAccountSelection", selectedAccount);
  }

  saveSelectedAccounts() {
    // let selectedAccount = [];
    // this.selection.selected.forEach(s => selectedAccount.push(s.id));
    this.updateSelectedAccountInLocalcache();
    this.dataService.savePlan();
    //this.onSave.emit();
    this.isDataChanged = false;
  }

  updateSelectedAccountInLocalcache(){
    let selectedAccounts = [];
      let selectedEAAccounts = [];
      this.selection.selected.forEach(s => {
        if(s.custodianType === fromModel.CUSTODIANTYPE.HypoEA){
          selectedEAAccounts.push(s.id);
        } else {
          selectedAccounts.push(s.id);
        }
      });
      this.contextService.dispatchAction(fromModel.APP_ACTION.SELECTEDACCOUNTS, "AccountListComponent-updateSelectedAccountInLocalcache", {selectedAccounts: selectedAccounts, selectedEAAccounts: selectedEAAccounts});    
      this.dataService.dispatchAction(fromModel.DATA_ACTION.SELECTEDPLANACCOUNTS, "AccountListComponent-updateSelectedAccountInLocalcache", {selectedAccounts: selectedAccounts, selectedEAAccounts: selectedEAAccounts});
  }

  // save(){
  //   this.saveSelectedAccounts();  
  // }

  refresh(){
    this.dataService.dispatchAction(fromModel.DATA_ACTION.EXTERNALACCOUNTS, "AccountListComponent-refresh", null);    
    this.dataService.getExternalAccountListByClientIds();
    this.populateHypotheticalAccList();
  }

  addHypotheticalAccount(clientid){
    window.open(Constant.uri.createEA + clientid, 'eawindow');
  }

  editHypotheticalAccount(eaid, clientid){
    window.open(`${Constant.uri.editEA}${eaid}?cid=${clientid}`, 'eawindow');
  }
    

  ngOnDestroy(): void{
    if(this._storeDataSubscription && this._storeDataSubscription !== null){
      this._storeDataSubscription.unsubscribe();
    }        
  }
}
